export default {
  model: [
    {
      label: 'Revista',
      field: 'magazine_id',
      type: 'text',
    },
    {
      label: 'Ano',
      field: 'year',
      type: 'text',
      min: 4,
      max: 4,
    },
    {
      label: 'Mês',
      field: 'month',
      type: 'text',
    },
    {
      label: 'Nº da edição',
      field: 'edition_number',
      type: 'text'
    }
  ]
}